/** @jsxImportSource @emotion/react */
import { Global } from '@emotion/react';
import React, { useState } from 'react';

import logo from '../../../images/logo.svg';
import { colors, Container } from '../../../ui';
import Burger from './burger';
import HeaderMobileMenu from './menu';

const HeaderMobile = React.memo(
  ({ activeSection, scrollTo, openTariffs, openVideo, inDevelopment }) => {
    const [open, setOpen] = useState(false);

    return (
      <>
        <Container
          css={{
            position: 'fixed',
            top: 0,
            borderBottom: `1px solid ${colors.black}`,
            height: 83,
            zIndex: 5,
            background: '#fff',
            boxShadow: `0px 2px 2px rgba(50, 50, 71, 0.06), 0px 2px 4px rgba(50, 50, 71, 0.06)`,
          }}
        >
          <header
            css={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <img src={logo} />

            <Burger open={open} onClick={() => setOpen(!open)} />
          </header>
        </Container>

        {open && (
          <>
            <HeaderMobileMenu
              activeSection={activeSection}
              scrollTo={scrollTo}
              openTariffs={openTariffs}
              onClose={() => setOpen(false)}
              openVideo={openVideo}
              inDevelopment={inDevelopment}
            />

            <Global styles={{ body: { overflowY: 'hidden' } }} />
          </>
        )}
      </>
    );
  }
);

export default HeaderMobile;
